/* Vitalys gift sync — mantiene los productos-regalo (0 €) del carrito
   alineados con la cantidad de pots de Taurine:
     >= 1 pot  -> Cuillère Doseuse
     >= 2 pots -> + Guide de Longévité Canine
   Config en data-attributes de [data-vitalys-gifts] (snippet vitalys-gift-ladder).
   Si los variant IDs están vacíos, no hace nada (modo solo-visual).
   07/10/2026 solo suscripción: cada pack (1/2/3 pots) tiene su plan Kaching con su
   descuento; al cambiar la cantidad de una línea de Taurine se cambia también su
   selling plan al del nuevo pack, conservando la frecuencia del peso (s/m/l). */
(function () {
  'use strict';

  var syncing = false;
  var pending = false;

  function config() {
    var el = document.querySelector('[data-vitalys-gifts]');
    if (!el) return null;
    var plans = null;
    try { plans = JSON.parse(el.getAttribute('data-taurine-plans') || 'null'); } catch (e) { plans = null; }
    return {
      plans: plans,
      taurineHandle: el.getAttribute('data-taurine-handle') || 'taurine',
      taurineVariant: el.getAttribute('data-taurine-variant') || '',
      gifts: [
        { variant: el.getAttribute('data-gift1-variant') || '', minQty: 1 },
        { variant: el.getAttribute('data-gift2-variant') || '', minQty: 2 }
      ].filter(function (g) { return g.variant; })
    };
  }

  function sectionsToRequest() {
    var list = ['cart-drawer', 'cart-icon-bubble'];
    var main = document.getElementById('main-cart-items');
    if (main && main.dataset.id) list.push(main.dataset.id);
    return list;
  }

  function renderSections(sections) {
    if (!sections) return;
    var drawerBox = document.getElementById('CartDrawer');
    if (drawerBox && sections['cart-drawer']) {
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var fresh = doc.querySelector('#CartDrawer');
      if (fresh) {
        drawerBox.innerHTML = fresh.innerHTML;
        var wrapper = document.querySelector('cart-drawer');
        var overlay = document.getElementById('CartDrawer-Overlay');
        if (wrapper && overlay) overlay.addEventListener('click', wrapper.close.bind(wrapper));
        if (wrapper) wrapper.classList.toggle('is-empty', !!doc.querySelector('.drawer__inner-empty'));
      }
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var doc2 = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      var el2 = doc2.querySelector('.shopify-section') || doc2.body;
      bubble.innerHTML = el2.innerHTML;
    }
    var main = document.getElementById('main-cart-items');
    if (main && main.dataset.id && sections[main.dataset.id]) {
      var doc3 = new DOMParser().parseFromString(sections[main.dataset.id], 'text/html');
      var freshContents = doc3.querySelector('.js-contents');
      var target = main.querySelector('.js-contents');
      if (freshContents && target) target.innerHTML = freshContents.innerHTML;
    }
  }

  // Plan que corresponde a `qty` pots conservando el peso (s/m/l) del plan actual
  function planFor(cfg, qty, currentPlanId) {
    if (!cfg.plans) return null;
    var tier = String(Math.min(Math.max(qty, 1), 3));
    var w = 'm';
    ['1', '2', '3'].forEach(function (t) {
      ['s', 'm', 'l'].forEach(function (k) {
        if (currentPlanId && cfg.plans[t] && String(cfg.plans[t][k]) === String(currentPlanId)) w = k;
      });
    });
    var id = cfg.plans[tier] && cfg.plans[tier][w];
    return id ? String(id) : null;
  }

  function sync() {
    var cfg = config();
    if (!cfg || !cfg.gifts.length) return;
    if (syncing) { pending = true; return; }
    syncing = true;

    fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // 1) plan de cada línea de Taurine coherente con su cantidad
        var fix = null;
        (cart.items || []).forEach(function (item) {
          if (fix || item.handle !== cfg.taurineHandle || !item.selling_plan_allocation) return;
          var cur = String(item.selling_plan_allocation.selling_plan.id);
          var want = planFor(cfg, item.quantity, cur);
          if (want && want !== cur) fix = { id: item.key, quantity: item.quantity, selling_plan: Number(want) };
        });
        if (fix) {
          fix.sections = sectionsToRequest();
          pending = true; // tras cambiar el plan, otra pasada para los regalos
          return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(fix)
          }).then(function (r) { return r.json(); });
        }

        // 2) regalos según el total de pots
        var taurineQty = 0;
        var current = {};
        (cart.items || []).forEach(function (item) {
          if (item.handle === cfg.taurineHandle) taurineQty += item.quantity;
          cfg.gifts.forEach(function (g) {
            if (String(item.variant_id) === String(g.variant)) current[g.variant] = item.quantity;
          });
        });

        var updates = {};
        cfg.gifts.forEach(function (g) {
          var want = taurineQty >= g.minQty ? 1 : 0;
          var have = current[g.variant] || 0;
          if (want !== have) updates[g.variant] = want;
        });

        if (!Object.keys(updates).length) return null;

        return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates, sections: sectionsToRequest() })
        }).then(function (r) { return r.json(); });
      })
      .then(function (data) {
        if (data && data.sections) renderSections(data.sections);
      })
      .catch(function (err) {
        if (window.console) console.warn('[vitalys-gift-sync]', err);
      })
      .finally(function () {
        syncing = false;
        if (pending) { pending = false; sync(); }
      });
  }

  function addPot(btn) {
    var cfg = config();
    if (!cfg || !cfg.taurineVariant) return;
    btn.disabled = true;
    fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = 0;
        var qty = 0;
        var curPlan = null;
        (cart.items || []).forEach(function (item, i) {
          if (!line && item.handle === cfg.taurineHandle) {
            line = i + 1;
            qty = item.quantity;
            curPlan = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.id : null;
          }
        });
        if (line) {
          // Incrementa la línea existente; con suscripción pasa al plan del pack siguiente
          var body = { line: line, quantity: qty + 1, sections: sectionsToRequest() };
          var nextPlan = planFor(cfg, qty + 1, curPlan);
          if (nextPlan) body.selling_plan = Number(nextPlan);
          return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body)
          }).then(function (r) { return r.json(); });
        }
        var addBody = { id: Number(cfg.taurineVariant), quantity: 1, sections: sectionsToRequest() };
        var firstPlan = planFor(cfg, 1, null);
        if (firstPlan) addBody.selling_plan = Number(firstPlan);
        return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(addBody)
        }).then(function (r) { return r.json(); });
      })
      .then(function (data) {
        if (data && data.sections) renderSections(data.sections);
        sync();
      })
      .catch(function (err) {
        if (window.console) console.warn('[vitalys-gift-sync] addPot', err);
      })
      .finally(function () { btn.disabled = false; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vitalys-add-pot]');
    if (btn) { e.preventDefault(); addPot(btn); }
  });

  var debounceTimer = null;
  function debouncedSync() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(sync, 200);
  }

  // pubsub.js del theme puede cargar DESPUÉS de este script (defer en orden de
  // documento) — reintentar la suscripción cuando el DOM esté listo.
  var subscribed = false;
  function trySubscribe() {
    if (subscribed) return;
    // PUB_SUB_EVENTS es un `const` de pubsub.js: NO cuelga de window — usar typeof
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, debouncedSync);
      subscribed = true;
    }
  }
  trySubscribe();
  document.addEventListener('DOMContentLoaded', trySubscribe);
  document.addEventListener('cart:refresh', debouncedSync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }

  window.VitalysGiftSync = { sync: sync };
})();
